import { useQuery } from "villus";
export const extractQueryName = (operation) => operation.query.definitions.find((d) => d.kind === "OperationDefinition")?.name?.value;
export function fetchQuery(queryDocument) {
  return () => {
    const { execute, isFetching } = useQuery({
      query: queryDocument,
      fetchOnMount: false
    });
    return {
      execute,
      isFetching
    };
  };
}
